import SixthSnapshotRevealPage from 'containers/6th-snapshot-reveal'

export default SixthSnapshotRevealPage

export const getStaticProps = async () => ({
  props: {
    pageTitle: 'DEADROP Snapshot VI Reveal',
  },
})
